/**
 * İçeriğin ses (müzik) olup olmadığının **tek** belirlemesi.
 *
 * ## Neden ayrı modül?
 *
 * Aynı soru iki yerde soruluyordu: `ItemCard.tsx` ve `HeroBanner.tsx` aynı
 * uzantı listesini, aynı `kind === 'music'` kontrolünü kendi kopyasıyla
 * yapıyordu. Kopyalar ayrıştıkça biri güncellenir diğeri eski kalır ve
 * ekran bir yerde "MÜZİK" diğer yerde "FİLM" yazar.
 *
 * İki kaynak birlikte aranır:
 *
 *   1. **Kütüphanenin medya türü** — güvenilir kaynak. Katalog başlıkları
 *      uzantısız geldiği için ("Aydilge - 05 - İstanbul") uzantıya bakmak
 *      yetmiyordu; ekran görüntüsünde müzik parçaları "FİLM" rozetiyle
 *      görünüyordu.
 *   2. **Başlıktaki uzantı** — tek kütüphane içinde karışık içerik varsa
 *      (örneğin "mixed" türünde bir kütüphane) yakalar.
 */

/** Ses dosyası uzantıları. */
const AUDIO_EXTENSIONS = ['.mp3', '.flac', '.wav', '.m4a', '.ogg', '.aac'];

export interface MediaKindSubject {
  kind: string;
  title: string;
}

/**
 * İçerik ses mi?
 *
 * @param item       Katalog öğesi
 * @param mediaKind  Kütüphanenin medya türü (`music` → içerik kesin ses)
 */
export function isAudioItem(
  item: MediaKindSubject,
  mediaKind: 'video' | 'music' = 'video',
): boolean {
  if (mediaKind === 'music') return true;
  if (item.kind === 'music') return true;
  const title = item.title.toLowerCase();
  return AUDIO_EXTENSIONS.some((extension) => title.endsWith(extension));
}
